/**
 * EntityLink — a clickable reference to something in the product.
 *
 * The href is a trodo://entity URI; ChatPage's document-level click delegation
 * intercepts it and opens the real in-chat drawer (users navigate to their
 * profile page). Everything else that once lived here — the fence-rendered
 * KPI rows, accordions, steppers, tables and user cards — is gone with the
 * fence format: the Answer Document's own renderer draws those blocks.
 */
import { trodoAnalyticsTheme as theme } from "features/analytics/studio/theme";

export function EntityLink({ kind, id, children, style }) {
  if (!kind || !id) return <>{children}</>;
  return (
    <a
      href={`trodo://entity/${kind}/${encodeURIComponent(id)}`}
      className="trodo-chat-entity-link"
      style={{
        color: theme.primary || "#ff8a5b",
        textDecoration: "none",
        cursor: "pointer",
        ...style,
      }}
      onMouseEnter={(e) => { e.currentTarget.style.textDecoration = "underline"; }}
      onMouseLeave={(e) => { e.currentTarget.style.textDecoration = "none"; }}
    >
      {children}
    </a>
  );
}
